import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import {
  HELP_TEXT_TRUNCATE_LIMIT,
  TruncatePipe,
} from '../../shared/pipes/truncate.pipe';

@Component({
  selector: 'app-help-text',
  standalone: true,
  imports: [CommonModule, NzToolTipModule, TruncatePipe],
  template: `
    <ng-container *ngIf="text">
      <span class="drawer-help-separator" aria-hidden="true">|</span>
      <span
        class="drawer-help-text"
        nz-tooltip
        [nzTooltipTitle]="text"
        [nzTooltipTrigger]="isTruncated ? 'hover' : null">
        {{ text | truncate }}
      </span>
    </ng-container>
  `,
  styles: [
    `
      .drawer-help-text {
        font-size: 13px;
        color: rgb(var(--gray-600));
        cursor: default;
      }

      .drawer-help-separator {
        color: rgb(var(--gray-300));
      }
    `,
  ],
})
export class HelpTextComponent {
  @Input() text: string | null = null;

  get isTruncated(): boolean {
    return (this.text ?? '').trim().length > HELP_TEXT_TRUNCATE_LIMIT;
  }
}
